import styled from 'styled-components';
import { ReactComponent as SpinnerSvg } from 'Images/Spinner.svg';
import colors from 'Styles/colors';

export const Wrapper = styled.div``;
export const SpinnerIcon = styled(SpinnerSvg)`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: inline-block;
  color: ${colors.blueCerulean};
  rect, path, circle, line, polyline, polygon {
    fill: currentColor;
    stroke: currentColor;
  }
`;
